@property --gradient-ring-angle {
  syntax: "<angle>";
  inherits: true;
  initial-value: 0deg;
}
@keyframes _1oa6zv46 {
  from {
    --gradient-ring-angle: 0deg;
  }
  to {
    --gradient-ring-angle: 360deg;
  }
}
._1oa6zv47 {
  --_1oa6zv41: color-mix(in srgb, var(--pluma-palette-violet-25) 80%, var(--pluma-color-surface-content));
  --_1oa6zv42: color-mix(in srgb, var(--pluma-palette-orange-25) 80%, var(--pluma-color-surface-content));
  --_1oa6zv43: color-mix(in srgb, var(--pluma-color-scope-neutral-subtle-border) 40%, transparent);
  --_1oa6zv44: color-mix(in srgb, var(--pluma-palette-orange-300) 60%, transparent);
  --_1oa6zv45: color-mix(in srgb, var(--pluma-palette-violet-500) 60%, transparent);
  display: inline-flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  border-radius: var(--_1oa6zv40);
  flex-shrink: 0;
  isolation: isolate;
  transition: box-shadow var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-entrance-expressive);
}
._1oa6zv47:hover {
  box-shadow: 0 0 0 var(--pluma-border-width-0125) var(--pluma-color-scope-neutral-subtle-border);
}
._1oa6zv47:focus-within {
  box-shadow: 0 0 0 var(--pluma-border-width-0125) var(--pluma-color-scope-neutral-subtle-border);
}
[data-pluma-color-scheme="dark"] ._1oa6zv47 {
  --_1oa6zv41: color-mix(in srgb, var(--pluma-palette-violet-950) 18%, var(--pluma-color-surface-content));
  --_1oa6zv42: color-mix(in srgb, var(--pluma-palette-orange-950) 18%, var(--pluma-color-surface-content));
  --_1oa6zv44: color-mix(in srgb, var(--pluma-palette-orange-300) 50%, transparent);
  --_1oa6zv45: color-mix(in srgb, var(--pluma-palette-violet-500) 50%, transparent);
}
._1oa6zv48 {
  position: absolute;
  inset: 0;
  z-index: 0;
  box-sizing: border-box;
  border-radius: var(--_1oa6zv40);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  border: var(--pluma-border-width-025) solid transparent;
  background-image: radial-gradient(112.04% 137.09% at 0% 14.29%, var(--_1oa6zv41) 0%, var(--_1oa6zv42) 100%), conic-gradient(from calc(var(--gradient-ring-angle) + 180deg), transparent 0deg, transparent 8deg, var(--_1oa6zv43) 14deg, var(--_1oa6zv44) 97deg, var(--_1oa6zv45) 180deg, var(--_1oa6zv44) 265deg, transparent 352deg);
  background-origin: padding-box, border-box;
  background-clip: padding-box, border-box;
  transition: opacity var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-entrance-expressive), visibility 0s linear var(--pluma-motion-duration-moderate-01);
}
[data-gradient-ring]:hover ._1oa6zv48, [data-gradient-ring]:focus-within ._1oa6zv48, [data-gradient-ring-active] ._1oa6zv48 {
  opacity: 1;
  visibility: visible;
  transition: opacity var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-entrance-expressive);
}
[data-gradient-ring-active] ._1oa6zv48 {
  animation: _1oa6zv46 6.336633663366337s linear infinite;
}
._1oa6zv49 {
  position: relative;
  z-index: 1;
  transition: background-color var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-standard-expressive), color var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-standard-expressive), box-shadow var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-standard-expressive), border-color var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-standard-expressive);
}
[data-gradient-ring]:hover ._1oa6zv49, [data-gradient-ring]:focus-within ._1oa6zv49, [data-gradient-ring-active] ._1oa6zv49 {
  background-color: transparent;
  background-image: none;
  color: var(--pluma-color-text-primary);
  border: var(--pluma-border-width-0125) solid transparent;
}
[data-gradient-ring]:hover ._1oa6zv49:not(:focus-visible), [data-gradient-ring]:focus-within ._1oa6zv49:not(:focus-visible), [data-gradient-ring-active] ._1oa6zv49:not(:focus-visible) {
  box-shadow: none;
}
@media (prefers-reduced-motion: reduce) {
  ._1oa6zv47 {
    transition: none;
  }
  ._1oa6zv48 {
    transition: none;
  }
  [data-gradient-ring]:hover ._1oa6zv48, [data-gradient-ring]:focus-within ._1oa6zv48, [data-gradient-ring-active] ._1oa6zv48 {
    transition: none;
  }
  [data-gradient-ring-active] ._1oa6zv48 {
    animation: none;
  }
  ._1oa6zv49 {
    transition: none;
  }
}